var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"predictor__reset",on:{"click":function($event){$event.preventDefault();return _vm.resetPredictor($event)}}},[_c('span',[_vm._v("reset to default")]),(_vm.isLoading)?_c('LoadingIndicator'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }